import type { RouteObject } from 'react-router';
import { RequirePermission } from '@/app/require-permission';
import { SiteEditorPage } from './editor-page';
import { PublicSiteRoot } from './public/public-site-root';

export const appRoutes: RouteObject[] = [
  {
    path: 'site',
    element: (
      <RequirePermission anyOf={['site.edit']}>
        <SiteEditorPage />
      </RequirePermission>
    ),
  },
];

/** Site público da barbearia: /b/:slug/* (sem layout do app, sem login). */
export const publicRoutes: RouteObject[] = [{ path: 'b/:slug/*', element: <PublicSiteRoot /> }];
